import { BaseService } from "./baseService";
import { DoctorDto } from "../types/doctor";
import apiClient from "./apiClient"; // (ή όπως το έχεις ονομάσει το αρχείο με το axios instance)

class DoctorService extends BaseService<DoctorDto, Record<string, any>> {
  constructor() {
    super("/Doctor");
  }

  // Νέα μέθοδος για τα μέλη
  async getMembers(signal?: AbortSignal): Promise<DoctorDto[]> {
    // Επειδή ο apiClient κάνει ήδη .data, παίρνεις απευθείας τη λίστα
    return await apiClient.get<any, DoctorDto[]>("/Doctor/members", {
      signal,
    });
  }
}

export const doctorService = new DoctorService();